import {combineReducers, type Reducer} from "redux";

import fileBetReducer from "@atg-horse/bet-history-receipts/src/domain/fileBetReducer";
import countryReducer from "@atg-horse-shared/country/domain/countryReducer";
import {HarryBoyFeeBracket} from "@atg-horse-shared/coupon";
import {horseFavoritesReducer} from "@atg-horse-shared/favorites";
import * as harryConfirmReducer from "@atg-horse-shared/horse-harry/domain/harryConfirmReducer";
import harryReducers from "@atg-horse-shared/horse-harry/domain/harryReducer";
import {QuickplayReducer} from "@atg-horse-shared/quickplay-domain";

import {storeApiReducer} from "../storeApiReducer";

import type {HorseState} from "@atg-horse-shared/horse-state";

type HorseAsyncType = {
    reducedBets: Reducer<any, any>;
};
export const createHorseReducer = (
    // @ts-expect-error
    asyncReducers: HorseAsyncType = {},
): Reducer<HorseState, any> => {
    const staticReducers = {
        horseFavorites: horseFavoritesReducer,
        proxyFileBet: fileBetReducer,
        quickplay: QuickplayReducer,
        country: countryReducer,
        harryBoyFeeBrackets: HarryBoyFeeBracket,
        ...harryReducers,
        ...harryConfirmReducer,
        storeApiReducer,
    };
    return combineReducers<any, any>({...staticReducers, ...asyncReducers});
};

export default createHorseReducer;
